module.exports = __webpack_public_path__ + "static/media/exam-prep-polygon-icon.4c80205c.png";